const connections = {
  PRODREG: 'Prodreg',
  ISAM: 'ISAM',
  DEFAULT: ''
};

export default connections;
